import React, { useEffect, useState } from "react";
import "./AdSlider.css";
import banner1 from './banner1.jpeg'
import banner2 from './banner2.webp'
import banner3 from './banner3.webp'
const AdSlider = () => {
  const slides = [
    { id: 1, src: banner1, alt: "slide1" },
    { id: 2, src: banner2, alt: "slide2" },
    { id: 3, src: banner3, alt: "slide3" }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length)
    }, 3000)
    return clearInterval(interval);
  }, [])
  return (
    <div className="ad-slider-container">
      <div className="ad-slider" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className="ad-slide"
          >
            <img src={slide.src} alt={slide.alt} />
          </div>
        ))}
      </div>

      {/* Scrollable thumbnails */}
      <div className="ad-thumbnails">
        {slides.map((slide, index) => (
          <img
            key={slide.id}
            src={slide.src}
            alt={slide.alt}
            className={`ad-thumb ${index === currentSlide ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default AdSlider;
